import React, { Component } from 'react';
import getTemplate from './getTemplate';
import ContentTemplate from './ContentTemplate';
import LeftMenuTemplate from './LeftMenuTemplate';
import LoginContentTemplate from './LoginContentTemplate';
import NotLoginContentTemplate from './NotLoginContentTemplate';

class PageLayout extends Component {
  render() {
    const { children } = this.props;
    return (
      <div id="container">
        <div id="lnb-wrap">{getTemplate(children, LeftMenuTemplate)}</div>
        {getTemplate(children, ContentTemplate)}
        {getTemplate(children, NotLoginContentTemplate)}
        {getTemplate(children, LoginContentTemplate)}
      </div>
    );
  }
}

export default PageLayout;
